import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#ton_svg__clip0_332_899)\"><path d=\"M24 48C37.2857 48 48 37.2857 48 24C48 10.7143 37.2857 0 24 0C10.7143 0 0 10.7143 0 24C0 37.2857 10.7143 48 24 48Z\" fill=\"#0098EA\"></path><path d=\"M32.228 13.3715H15.7708C12.7708 13.3715 10.8851 16.6286 12.3422 19.2857L22.4565 36.8572C23.1422 37.9715 24.7708 37.9715 25.4565 36.8572L35.5708 19.2857C37.1137 16.6286 35.228 13.3715 32.228 13.3715ZM22.5422 31.5429L20.3137 27.2572L14.9994 17.7429C14.6565 17.1429 15.0851 16.3715 15.8565 16.3715H22.5422V31.5429ZM32.9994 17.7429L27.6851 27.2572L25.4565 31.5429V16.3715H32.1422C32.9137 16.3715 33.3422 17.1429 32.9994 17.7429Z\" fill=\"white\"></path></g><defs><clipPath id=\"ton_svg__clip0_332_899\"><rect width=\"48\" height=\"48\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }